// import { isValidDate, isValidBirthDate } from '@usas/ui-web/utils/validation';
// import Constants from '@usas/ui-web/utils/Constants';

export const localValidate = (formState) => {
  let errors = {};

  //Competition Category 
  if (!formState.competitionGenderTypeId) {
    errors.competitionGenderTypeId = 'Competition Category is required';
  }

  return errors;
};

const MemberCompetitionCategoryValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default MemberCompetitionCategoryValidation;